// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"animations_fadeIn__EVkXL","fadeOut":"animations_fadeOut__mRYNE","tooltip":"Tooltip_tooltip__Lr7oB","wrapperButton":"Tooltip_wrapperButton___p7NZ"};